let counter = 0;
const interval = setInterval(() => {
    if (BSS_B2B && window.location.pathname.includes("cart")) {
        document.querySelector(".cart__original-total.fs-body-base").style.display = "none";
        document.querySelector(".cart__discounts.fs-body-base").style.display = "none";
        const cartIcon = document.querySelector("[data-js-cart-icon]");
        if (cartIcon) {
        const clone = cartIcon.cloneNode(true);
        cartIcon.replaceWith(clone);

        clone.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = "/cart";
        });
        }
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

document.querySelector(".quick-cart__discounts.c-subdued").style.display = "none";

